import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Defer service worker registration to after page load (LCP optimization)
// This prevents registerSW.js from blocking the initial render
if ("serviceWorker" in navigator) {
  const registerSW = async () => {
    try {
      const { registerSW: register } = await import("virtual:pwa-register");
      register({
        immediate: true,
        onRegistered(registration) {
          console.log("SW registered:", registration);
        },
        onRegisterError(error) {
          console.error("SW registration error:", error);
        },
      });
    } catch (e) {
      console.log("SW registration skipped:", e);
    }
  };

  // Use requestIdleCallback for non-critical work, fallback to setTimeout
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(() => registerSW(), { timeout: 3000 });
  } else {
    globalThis.addEventListener("load", () => {
      setTimeout(registerSW, 1000);
    });
  }
}
